import { render, staticRenderFns } from "./Co02Page.vue?vue&type=template&id=1a2457b2"
import script from "./Co02Page.vue?vue&type=script&lang=js"
export * from "./Co02Page.vue?vue&type=script&lang=js"
import style0 from "./Co02Page.vue?vue&type=style&index=0&id=1a2457b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports